import { render, staticRenderFns } from "./ExperimentConfig.vue?vue&type=template&id=50140ac9&scoped=true"
import script from "./ExperimentConfig.vue?vue&type=script&lang=js"
export * from "./ExperimentConfig.vue?vue&type=script&lang=js"
import style0 from "./ExperimentConfig.vue?vue&type=style&index=0&id=50140ac9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50140ac9",
  null
  
)

export default component.exports